// src/Components/layout/Sidebar.jsx
import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard, Users, FileText,
  Network, MessageSquare, Sparkles, Settings, ChevronLeft, ChevronRight,
} from 'lucide-react';
import { ShieldAlert } from "lucide-react";

// Import logos
import logoFull from '../../LOGOS/Taglined Registered Logo.png';
import logoIcon from '../../LOGOS/Beetroot Icon.png';

const NAV = [
  { path: '/dashboard',                   label: 'Overview',        icon: LayoutDashboard, end: true  },
  { path: '/dashboard/user-analytics',    label: 'Users',           icon: Users                       },
  { path: '/dashboard/content-analytics', label: 'Content',         icon: FileText                    },
  { path: '/dashboard/connections',       label: 'Connections',     icon: Network                     },
  { path: '/dashboard/messages',          label: 'Messages',        icon: MessageSquare               },
  { path: '/dashboard/communities',       label: 'Communities',     icon: Users                       },
  { path: '/dashboard/ai-advisory',       label: 'AI Advisory',     icon: Sparkles                    },
  { path: '/dashboard/moderation',        label: 'Moderation',      icon: ShieldAlert                 },                 
  { path: '/dashboard/settings',          label: 'Settings',        icon: Settings                    },
];

export default function Sidebar() {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <aside
      className={`
        h-screen flex flex-col flex-shrink-0
        bg-[#0F0F0F] text-white
        border-r border-white/5
        transition-all duration-300 ease-in-out
        ${collapsed ? 'w-[68px]' : 'w-[220px]'}
      `}
    >
      {/* Logo row */}
      <div className={`flex items-center h-16 px-4 border-b border-white/5 flex-shrink-0 ${collapsed ? 'justify-center' : 'justify-between'}`}>
        {!collapsed && (
          <img src={logoFull} alt="Beetroot" className="h-8 w-auto object-contain" />
        )}
        {collapsed && (
          <img src={logoIcon} alt="Beetroot" className="w-8 h-8 object-contain" />
        )}
        <button
          onClick={() => setCollapsed(v => !v)}
          className={`p-1.5 rounded-lg text-white/30 hover:text-white hover:bg-white/8 transition-colors ${collapsed ? 'hidden' : ''}`}
        >
          <ChevronLeft size={16} />
        </button>
      </div>

      {/* Expand button when collapsed */}
      {collapsed && (
        <button
          onClick={() => setCollapsed(false)}
          className="mx-auto mt-2 p-1.5 rounded-lg text-white/30 hover:text-white hover:bg-white/8 transition-colors"
        >
          <ChevronRight size={16} />
        </button>
      )}

      {/* Nav section label */}
      {!collapsed && (
        <p className="px-4 pt-6 pb-2 text-[10px] font-semibold tracking-widest text-white/25 uppercase">
          Analytics
        </p>
      )}

      {/* Nav items */}
      <nav className="flex-1 px-2 space-y-0.5 overflow-y-auto">
        {NAV.map(item => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.end}
            className={({ isActive }) => `
              flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium
              transition-all duration-150
              ${isActive
                ? 'bg-red-600 text-white shadow-lg shadow-red-900/30'
                : 'text-white/50 hover:text-white hover:bg-white/6'
              }
              ${collapsed ? 'justify-center px-2' : ''}
            `}
          >
            <item.icon size={18} className="flex-shrink-0" />
            {!collapsed && <span>{item.label}</span>}
          </NavLink>
        ))}
      </nav>

      {/* Footer */}
      {!collapsed && (
        <div className="p-4 border-t border-white/5 flex-shrink-0">
          <div className="flex items-center gap-2.5">
            <div className="w-7 h-7 rounded-full bg-gradient-to-br from-red-500 to-orange-500 flex items-center justify-center text-xs font-bold text-white flex-shrink-0">
              A
            </div>
            <div className="min-w-0">
              <p className="text-xs font-semibold text-white/70 truncate">Admin</p>
              <p className="text-[10px] text-white/30 truncate">Super Admin</p>
            </div>
          </div>
        </div>
      )}
    </aside>
  );
}